import React from 'react'
import { Formik, FormikProps, Form } from 'formik'
import ValidatedTextField from '../../../_global/ValidatedTextField'
import { Box, Grid, Typography } from '@material-ui/core'
import ValidatedAutocomplete from '../../../_global/ValidatedAutocomplete'
import pitchValidationSchema from './validationSchema'
import { useOnboarding } from '../../../contexts/OnboardingContext'
import { useMutation } from '@apollo/react-hooks'
import createOrUpdatePitchMutation from '../../../apolloClient/mutations/createOrUpdatePersonalSummary'
import PITCH_QUERY from '../../../apolloClient/queries/getPitch'
import { useAuth0 } from '../../../contexts/Auth0Context'
import FormActions from '../../../_global/FormActions'

const Pitch = ({ initialValues }) => {
  const { logout } = useAuth0()

  const { back, currentExpert, formRef, next: nextStep, step } = useOnboarding()

  const [pitchMutation] = useMutation(createOrUpdatePitchMutation)

  const buildPitchMutationInput = (values) => {
    return {
      expertId: currentExpert.id,
      input: {
        id: values.id,
        aboutYourself: values.aboutYourself,
        topIndustries: values.topIndustries,
        topFinancialSkills: values.topFinancialSkills,
        topSoftwareSkills: values.topSoftwareSkills,
        whyFreelanceWork: values.whyFreelanceWork,
      },
    }
  }

  const handleSubmit = async (values) => {
    await pitchMutation({
      variables: buildPitchMutationInput(values),
      refetchQueries: [{ query: PITCH_QUERY, variables: { id: currentExpert.id } }],
    }).then((result) => {
      if (values.isSaveAndExit) {
        logout()
      } else {
        if (step !== 7) {
          nextStep()
        }
      }
    })
  }

  return (
    <Formik
      validateOnMount={true}
      initialValues={initialValues}
      validationSchema={pitchValidationSchema}
      onSubmit={handleSubmit}
      innerRef={formRef}
    >
      {(props: FormikProps<any>) => {
        const { isSubmitting, isValid, setFieldValue, values } = props
        return (
          <Form autoComplete="off">
            <Box mb={4}>
              <Typography variant="body2">
                Please write a brief bio that we can use when introducing you to clients
              </Typography>
              <ValidatedTextField multiline rows={4} name="aboutYourself" autoComplete="off" />
              <Typography variant="body2" style={{ color: '#bbb' }}>
                A few things to make sure you include are: Professional expertise, Education and certifications, and
                something that humanizes you &#40;ie "Samantha runs marathons", "is an avid fisherman", "is a lifelong
                Cubs fan", etc.&#41;
              </Typography>
            </Box>

            <Grid container spacing={3}>
              <Grid item>
                <Typography variant="body2" paragraph>
                  From your work and project experience tags, please select your top industries. (up to 5)
                </Typography>
                <ValidatedAutocomplete
                  name="topIndustries"
                  options={values.industryTags}
                  onChange={(_, valuesArray) => {
                    setFieldValue('topIndustries', valuesArray, true)
                  }}
                  multiple={true}
                />
              </Grid>
              <Grid item>
                <Typography variant="body2" paragraph>
                  From your work and project experience tags, please select your top skills. (up to 5)
                </Typography>
                <ValidatedAutocomplete
                  name="topFinancialSkills"
                  options={values.financialTags}
                  onChange={(_, valuesArray) => {
                    setFieldValue('topFinancialSkills', valuesArray, true)
                  }}
                  multiple={true}
                />
              </Grid>
              <Grid item>
                <Typography variant="body2" paragraph>
                  From your work and project experience tags, please select your top softwares of expertise. (up to 5)
                </Typography>
                <ValidatedAutocomplete
                  name="topSoftwareSkills"
                  options={values.softwareTags}
                  onChange={(_, valuesArray) => {
                    setFieldValue('topSoftwareSkills', valuesArray, true)
                  }}
                  multiple={true}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body2">Why do you want to do freelance work?</Typography>
                <ValidatedTextField multiline rows={4} name="whyFreelanceWork" autoComplete="off" />
              </Grid>
            </Grid>
            {step !== 7 && <FormActions step={step} back={back} isValid={isValid} isSubmitting={isSubmitting} />}
          </Form>
        )
      }}
    </Formik>
  )
}

export default Pitch
